import React from "react";
import { SectionPoster } from "../shared/PosterTemplate";

const Tourism = ({parentPath}) =>
  <SectionPoster sectionName='tourism' backRoute={parentPath} />

export default Tourism;